<template>
  <div class="appointment">
    <div v-if="!show">
      <div class="avt">
        <div style="font-weight: 600; margin-bottom: 4px">
          {{ spotlist.name }}
        </div>
        <!-- <div style="font-size: 0.14rem">活动日期：{{ spotlist.startDate }}</div> -->
      </div>
      <div class="appointment-content">
        <div class="date">
          <div class="big-title">日期</div>
        </div>
        <div class="datelist">
          <div
            v-for="(item, index) in datelist"
            :key="index"
            class="datelist-item"
            :class="dateindex == index ? 'active' : ''"
            :style="{
              marginLeft: index % 4 == 0 ? '' : '4%',
            }"
            @click="changedateindex(index)"
          >
            {{ item.slice(5) }}
          </div>
        </div>
        <div class="date">
          <div class="big-title">时间</div>
        </div>
        <div class="timelist">
          <div
            v-for="(item, index) in timelist"
            :key="index"
            style="width: 48%"
          >
            <!-- 先判断一下是时间段是否过期 -->
            <div
              v-if="getoverdue(item.end) || isclose != -1"
              class="timelist-item1"
            >
              <div
                style="
                  font-size: 0.16rem;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                "
              >
                {{ item.start }}-{{ item.end }}
              </div>
            </div>
            <!-- 再判断一下余票是否为0 -->
            <div
              v-else-if="item.leftQuantity == 0 && item.limitCount != -1"
              class="timelist-item1"
            >
              <div
                style="
                  font-size: 0.16rem;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                "
              >
                {{ item.start }}-{{ item.end }}
                <span style="font-size: 0.12rem; margin-right: 0.1rem"
                  >名额已满</span
                >
              </div>
            </div>
            <!-- 两者都不存在才可以选择 -->
            <div
              @click="changetime(index)"
              v-else
              class="timelist-item"
              :class="timeindex == index ? 'active' : ''"
            >
              <div style="font-size: 0.16rem">
                {{ item.start }}-{{ item.end }}
              </div>
            </div>
          </div>
        </div>
        <div class="date peopledate">
          <div class="big-title">出行人信息</div>
          <div style="color: #a78d60" @click="$router.push('/orderCenter')">
            我的报名
          </div>
        </div>
        <div class="people-content">
          <div
            v-for="(item, index) in peoplelist"
            :key="index"
            class="people-item"
          >
            <div
              class="item-left"
              v-if="ischange(item.id)"
              :class="index != 0 ? 'active' : ''"
            >
              <div class="change">
                <img
                  src="../assets/delete.png"
                  alt=""
                  @click="changepeople(item.id)"
                />
              </div>
              <div class="data">
                <div style="font-size: 0.18rem; color: #000">
                  {{ item.name }}
                </div>
                <div>
                  <span>{{ item.cardType }}</span> {{ item.idCard }}
                </div>
                <div><span>手机号</span>{{ item.phone }}</div>
              </div>
            </div>
          </div>
          <div class="addshow-outer">
            <div class="addshow" @click="show = true">添加</div>
          </div>
        </div>
      </div>
      <div class="appointment-bottom">
        <div class="sumbit1" @click="$router.push('/List/' + id)">活动列表</div>
        <div class="sumbit2" @click="sumbit">报名</div>
      </div>
      <el-dialog
        :visible.sync="promptshow"
        width="85%"
        :show-close="false"
        :close-on-click-modal="false"
        class="el-dialog-centent"
      >
        <div class="pull-con">
          <div class="pull-con-title1">温馨提示</div>
          <div class="pull-con-title2">
            <p>
              1、我馆实行实名、全报名制度。有效报名证件为身份证、护照、港澳通行证、台胞证。
            </p>
            <p>
            2、每张有效身份证件每时段仅可报名一次,每个账号每天最多实名报名3人,每人的姓名和有效证件号码均需如实填写（小孩也需报名）,信息与本人不符将不能入馆。
            </p>
            <p>
             3、报名成功后,参观当日凭本人身份证或报名码等有效证件通过信息核验。（截图无效）
            </p>
            <p>4、疫情防控期间暂停接受各种形式的团队参观报名服务。</p>
            <p>5、如您不能按时到馆,请提前取消报名。连续2次或累计3次(30天之内)报名未到馆,将触发限制报名机制,限制报名机制触发之后30日内将无法进行报名参观.</p>
            <p>6、报名成功后根据报名时间准时前往参观,该场次开始10分钟后,不再安排入馆,谢谢理解和配合!</p>
            <p style="color: red; font-weight: 600">
              我承诺:参观前10天内没有境外旅居史或参
              观前7天没有国内疫情中、高风险区所在县 （市、区、旗）旅居史。
            </p>
          </div>
          <el-checkbox v-model="radio" style="margin-top: 0.1rem"
            >我已同意并阅读</el-checkbox
          >
          <div>《报名须知》</div>
          <div class="pull-con-title3" @click="sumbit" v-if="radio">
            继续报名
          </div>
          <div class="no-pull-con-title3" v-else>继续报名</div>
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="validationshow"
        width="70%"
        :show-close="false"
        :close-on-click-modal="false"
        class="el-dialog-centent"
      >
        <div class="pull-con">
          <div class="pull-con-title1">温馨提示</div>
          <div class="pull-con-title2">
            {{ validationtext }}
          </div>
          <div class="pull-con-title3" @click="validationshow = false">
            知道了
          </div>
        </div>
      </el-dialog>
    </div>
    <people :peopleindex="peopleindex" @changeshow="myshow" v-else></people>
  </div>
</template>
<script>
import people from "../components/people.vue";
export default {
  data() {
    return {
      radio: false,
      id: "",
      date: "",
      spotlist: "",
      timelist: "",
      timeindex: null,
      datelist: "",
      dateindex: 0,
      show: false,
      peopleindex: [],
      peoplelist: "",
      promptshow: false,
      validationshow: false,
      validationtext: "",
      nochange: 0,
      close: "",
      isclose: -1,
    };
  },
  components: {
    people,
  },
  watch: {
    date(val) {
      this.getdata();
      this.timeindex = null;
      this.isclose = this.close.indexOf(val);
    },
    //添加出行人后重新获取一下出现人列表
    show(val) {
      if (!val) {
        this.$axios.get("/userpeo/list").then((res) => {
          this.peoplelist = res.data;
          this.peoplelist.forEach(element => {
            this.$set(element,'idCard',this.$crypto.decrypt(element.idCard,"Mse1FuwMgIF6cR5p","Xadiapdfaxi0s91D"))
        });
        });
      }
    },
  },
  created() {
    this.myolad();
  },
  mounted() {
    this.scrollwidth =
      document.getElementsByClassName("datelist")[0].clientWidth;
  },
  methods: {
    myolad() {
      this.id = this.$route.params.id;
      //获取出行人列表
      this.$axios.get("/userpeo/list").then((res) => {
        this.peoplelist = res.data;
        this.peoplelist.forEach(element => {
            this.$set(element,'idCard',this.$crypto.decrypt(element.idCard,"Mse1FuwMgIF6cR5p","Xadiapdfaxi0s91D"))
        });
        if (res.data[0]) {
          this.peopleindex.push(res.data[0].id);
        }
      });
      //获取活动信息
      this.$axios.get(`/book/activInfo/${this.id}`).then((res) => {
        this.spotlist = res.data.bookActiv;
        let datelist = [];
        if (res.data.bookActiv.closeDate) {
          this.close = JSON.parse(res.data.bookActiv.closeDate);
        }
        res.data.bookOpenTimes.forEach((element) => {
          if (datelist.indexOf(element.appointDate) == -1) {
            datelist.push(element.appointDate);
          }
        });
        this.datelist = datelist;
        this.date = this.datelist[0];
      });
    },
    //获取开放时间
    getdata() {
      this.$axios
        .get(`/book/activInfo/${this.id}/?date=${this.date}`)
        .then((res) => {
          this.timelist = res.data.bookOpenTimes;
        });
    },
    //点击日期
    changedateindex(index) {
      this.dateindex = index;
      this.date = this.datelist[index];
    },
    //点击时间
    changetime(index) {
      this.timeindex = index;
    },
    // 取消出行人
    changepeople(id) {
      let deleteindex = this.peopleindex.findIndex((value) => {
        return value == id;
      });
      this.$delete(this.peopleindex, deleteindex);
    },
    // 判断是否为选中出行人
    ischange(id) {
      let show = false;
      this.peopleindex.forEach((element) => {
        if (id == element) {
          show = true;
        }
      });
      return show;
    },
    //报名提交
    sumbit() {
      if (!this.date) {
        this.validationtext = "请选择报名日期";
        this.validationshow = true;
        return false;
      }
      if (this.timeindex == null) {
        this.validationtext = "请选择报名时间";
        this.validationshow = true;
        return false;
      }
      if (this.peopleindex.length == 0) {
        this.validationtext = "至少勾选一个出行人";
        this.validationshow = true;
        return false;
      }
      if (this.nochange == 0) {
        this.promptshow = true;
        this.nochange = 1;
        return false;
      } else {
        this.promptshow = false;
      }
      let datalist = [];
      this.peopleindex;
      this.peopleindex.forEach((element) => {
        for (const key in this.peoplelist) {
          if (this.peoplelist[key].id == element) {
            datalist.push({
              travelId: element,
              tourId: this.spotlist.tourId,
              identity: this.$crypto.encrypt(this.peoplelist[key].idCard,"Mse1FuwMgIF6cR5p","Xadiapdfaxi0s91D"),
              activId: this.id,
              name: this.peoplelist[key].name,
              phone: this.peoplelist[key].phone,
              appointDate: this.date,
              appointTimeStart: this.timelist[this.timeindex]["start"],
              appointTimeEnd: this.timelist[this.timeindex]["end"],
            });
            break;
          }
        }
      });
      this.$axios.post("/book/appointment", datalist).then((res) => {
        if (res.code == 200) {
          this.$router.push("/orderCenter");
        }
      });
    },
    //当关闭添加出现人页面,滚动到页面底部
    myshow() {
      this.show = false;
      this.$nextTick(() => {
        let Height1 =
          document.body.clientHeight || document.documentElement.clientHeight;
        let Height2 =
          document.getElementsByClassName("appointment")[0].offsetHeight;
        document.documentElement.scrollTop = Height2 - Height1;
      });
    },
    //判断报名时间段是否过期
    getoverdue(val) {
      let valitem =
        new Date(`${this.date} ${val}:00`).getTime() ||
        new Date(`${this.date}T${val}:00`).getTime();
      if (new Date().getTime() > valitem) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style>
.el-dialog-centent {
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-dialog {
  margin: 0 0 !important;
  display: flex;
  flex-direction: column;
}
.el-dialog__header {
  display: none;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #a78d60;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #a78d60;
  border-color: #a78d60;
}
</style>
<style>
.big-title {
  font-size: 0.22rem;
  font-weight: 550;
}
</style>
<style scoped lang="less">
.appointment {
  min-height: 100%;
  position: relative;
  .avt {
    background-color: #a78d60;
    width: 100%;
    padding: 0.2rem 0.2rem 0.4rem 0.2rem;
    box-sizing: border-box;
    // height: 1.2rem;
    font-size: 0.18rem;
    color: #fff;
    .avt-item {
      padding-bottom: 4px;
      color: #ccc;
    }
    .active {
      border-bottom: 3px solid #fff;
      color: #fff;
    }
  }
  .appointment-content {
    background-color: #fff;
    border-top-left-radius: 0.15rem;
    border-top-right-radius: 0.15rem;
    position: relative;
    top: -0.2rem;
    padding: 0 0.2rem;
    box-sizing: border-box;
    .date {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.3rem 0 0.1rem 0;
      .mydate {
        color: #a78d60;
      }
    }
    .datelist {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      padding-right: 1px;
      // justify-content: space-between;
      .datelist-item {
        width: 22%;
        // margin-right: 2%;
        flex-shrink: 0;
        background-color: #fff;
        line-height: 0.4rem;
        text-align: center;
        border-radius: 0.05rem;
        border: 1px solid rgba(151, 151, 151, 0.4);
        font-size: 0.16rem;
        display: inline-block;
        box-sizing: border-box;
        margin-bottom: 0.2rem;
      }
      .active {
        border: 1px solid #a78d60;
        background-color: #a78d60;
        color: #fff;
      }
    }
    .timelist {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .timelist-item {
        background-color: #fff;
        flex-shrink: 0;
        width: 100%;
        border-radius: 0.05rem;
        border: 1px solid #979797;
        margin-bottom: 0.1rem;
        padding: 0.1rem 0 0.1rem 0.1rem;
        box-sizing: border-box;
        .Quantity {
          color: #807e7e;
          font-size: 0.12rem;
        }
        .active1 {
          color: #fff;
        }
      }
      .timelist-item1 {
        background-color: #fff;
        flex-shrink: 0;
        width: 100%;
        border-radius: 0.05rem;
        border: 1px solid #979797;
        margin-bottom: 0.1rem;
        padding: 0.1rem 0 0.1rem 0.1rem;
        box-sizing: border-box;
        color: #807e7e;
        opacity: 0.4;
      }
      .active {
        background-color: #a78d60;
        color: #fff;
        border: 1px solid #a78d60;
      }
    }
    .peopledate {
      padding: 0.1rem 0 0 0;
      margin-top: 0.3rem;
      height: 0.3rem;
      border-top: 1px solid rgba(167, 141, 96, 0.5);
    }
    .people-content {
      padding-bottom: 0.6rem;
      .people-item {
        .item-left {
          display: flex;
          align-items: flex-start;
          padding-top: 0.15rem;
          padding-bottom: 0.1rem;
          border-bottom: 1px solid rgba(20, 35, 35, 0.2);
          .change {
            width: 0.2rem;
            height: 0.2rem;
            margin-right: 0.2rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .data {
            margin-left: 0.2rem;
            line-height: 0.25rem;
            color: #868686;
            font-size: 0.13rem;
            span {
              margin-right: 0.1rem;
            }
          }
        }

        .editor {
          font-size: 0.2rem;
          vertical-align: text-top;
        }
      }
      .addshow-outer {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.14rem;
        margin-top: 0.3rem;
        .addshow {
          background: rgba(167, 141, 96, 0.2);
          border-radius: 23px;
          padding: 0 0.3rem;
          color: #a78d60;
          line-height: 0.3rem;
          text-align: center;
          display: flex;
          align-items: center;
        }
      }
    }
  }
  .appointment-bottom {
    width: 100%;
    padding: 0 0.2rem;
    box-sizing: border-box;
    position: absolute;
    bottom: 0.2rem;
    display: flex;
    justify-content: space-between;
    // justify-content: center;
    .sumbit1 {
      border: 1px solid #a78d60;
      line-height: 0.4rem;
      color: #a78d60;
      width: 45%;
      text-align: center;
      border-radius: 0.03rem;
    }
    .sumbit2 {
      background-color: #a78d60;
      line-height: 0.4rem;
      color: #fff;
      width: 45%;
      text-align: center;
      border-radius: 0.03rem;
    }
  }
  .pull-con {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .pull-con-title1 {
      font-weight: 500;
      color: #142323;
      letter-spacing: 1px;
      font-size: 0.2rem;
      font-weight: 600;
      text-align: center;
    }
    .pull-con-title2 {
      margin-top: 0.2rem;
      font-size: 0.12rem;
      p {
        margin-bottom: 0.1rem;
        color: #142323;
        letter-spacing: 2px;
      }
    }
    .pull-con-title3 {
      color: #fff;
      width: 80%;
      line-height: 0.31rem;
      background-color: #a78d60;
      font-size: 0.14rem;
      text-align: center;
      border-radius: 0.04rem;
      margin-top: 0.2rem;
    }
    .no-pull-con-title3 {
      color: #fff;
      width: 80%;
      line-height: 0.31rem;
      background-color: #f1eadd;
      font-size: 0.14rem;
      text-align: center;
      border-radius: 0.04rem;
      margin-top: 0.2rem;
    }
  }
}
</style>